import { render } from "./HkBtnUploadModal.vue?vue&type=template&id=e95b065c"
import script from "./HkBtnUploadModal.vue?vue&type=script&lang=js"
export * from "./HkBtnUploadModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__